import { create } from "zustand";
import { persist } from "zustand/middleware";
import { setSentryUser } from "../lib/sentry";

interface AuthState {
  username: string | null;
  /** The signed-in user's id (access-token `sub`): 32 lowercase hex or a ULID. */
  userId: string | null;
  channel: string | null;
  pubnubGroupChannel: string | null;
  hasInformation: boolean | null;
  setUser: (username: string, userId: string) => void;
  setChannel: (channel: string | null) => void;
  setPubnubGroupChannel: (ch: string) => void;
  setHasInformation: (v: boolean) => void;
  clearAuth: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      username: null,
      userId: null,
      channel: null,
      pubnubGroupChannel: null,
      hasInformation: null,
      setUser: (username, userId) => {
        set({ username, userId });
        setSentryUser(userId);
      },
      setChannel: (channel) => set({ channel }),
      setPubnubGroupChannel: (ch) => set({ pubnubGroupChannel: ch }),
      setHasInformation: (v) => set({ hasInformation: v }),
      clearAuth: () => {
        set({
          username: null,
          userId: null,
          channel: null,
          pubnubGroupChannel: null,
          hasInformation: null,
        });
        setSentryUser(null);
      },
      isAuthenticated: () => get().username !== null,
    }),
    {
      name: "auth-storage",
      // v1: `uuid` became `userId` (one user id). An older saved state is dropped (signed out): sign in once.
      version: 1,
      migrate: () => ({ username: null, userId: null, hasInformation: null }),
      partialize: (state) => ({
        username: state.username,
        userId: state.userId,
        hasInformation: state.hasInformation,
      }),
    },
  ),
);
